import React, {Component} from 'react';

import {Table, Divider, Tag, Button, Icon, Rate, Alert} from 'antd';

class Antd extends Component {

    handleClick = (id) => {
        console.log(id)
    }

    render() {

        const columns = [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                render: (text, record) => (<span onClick={() => {
                    this.handleClick(record.key)
                }} style={{color: 'red'}}>{text}</span>),
            },
            {
                title: 'Age',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: 'Address',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: 'Tags',
                key: 'tags',
                dataIndex: 'tags',
                render: tags => (
                    <span>
                        {tags.map(tag => {
                            let color = tag.length > 5 ? 'geekblue' : 'green';
                            if (tag === 'loser') {
                                color = 'volcano';
                            }
                            return (
                                <Tag color={color} key={tag}>
                                    {tag.toUpperCase()}
                                </Tag>
                            );
                        })}
                      </span>
                ),
            },
            {
                title: 'Action',
                key: 'action',
                render: (text, record) => (
                    <span>
                    <span>Invite {record.name}</span>
                    <Divider type="vertical"/>
                    <span>Delete</span>
                  </span>
                ),
            },
        ];

        const data = [
            {
                key: '1',
                name: 'John Brown',
                age: 32,
                address: 'New York No. 1 Lake Park',
                tags: ['nice', 'developer'],
            },
            {
                key: '2',
                name: 'Jim Green',
                age: 42,
                address: 'London No. 1 Lake Park',
                tags: ['loser'],
            },
            {
                key: '3',
                name: 'Joe Black',
                age: 32,
                address: 'Sidney No. 1 Lake Park',
                tags: ['cool', 'teacher'],
            },
        ];

        return (
            <div>
                <Table columns={columns} dataSource={data}/>

                <Button type="primary">Button</Button>
                <Icon type="area-chart"/>

                <Rate/>

                <div style={{width: 300}}>

                    <div>
                        <Alert message="Success Tips" type="success" showIcon/>
                        <Alert message="Informational Notes" type="info" showIcon/>
                        <Alert message="Warning" type="warning" showIcon/>
                        <Alert message="Error" type="error" showIcon/>

                    </div>
                </div>


            </div>
        );
    }
}

export default Antd;